@if (hasAtLeastAdministratorRole()) {
  <a (click)="openImportDialog()" data-test="monitor__import-data">
    {{ 'upload.title' | translate }}
  </a>
}
